module.exports = __webpack_public_path__ + "static/img/6629_phase_function_Paper_PointsHejduk_Prediction.43e7562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6629_phase_function_Paper_PointsHejduk_Prediction.png
// module id = j7co
// module chunks = 0